import { combineReducers } from 'redux';

import { reducer as form } from './State/form';
import { reducer as submitting } from './State/submitting';
import { reducer as supplierItem } from './State/supplierItem';

export default combineReducers({
  form,
  submitting,
  supplierItem,
});
